import React, { FC, useState } from "react";
import { Box, Button, Divider, Menu, MenuItem } from "@mui/material";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import RoleManagement from "../../security/roleManagement";

export type MenuObject = {
    text: string;
    onPress: (() => void) | (() => Promise<void>);
    dividerNext?: boolean;
    showToUser: boolean;
};

interface MenuComponentProps {
    disabled?: boolean;
    options: MenuObject[];
    menuAnchorElement?: React.FC;
}

const MenuComponent: FC<MenuComponentProps> = ({ options, menuAnchorElement, disabled = false }) => {
    const [anchorElement, setAnchorElement] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorElement);
    const MenuAnchorElement: React.FC = menuAnchorElement || (() => null);
    const finalOptions = options.filter(option => option.showToUser);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorElement(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorElement(null);
    };

    const handleOptionClick = (option: MenuObject) => {
        option.onPress();
        handleClose(); 
    };

    return (
        <Box>
            <Button disabled={disabled} color="inherit" onClick={handleClick}>
                {menuAnchorElement ? (
                    <MenuAnchorElement />
                ) : (
                    <AccountCircleIcon sx={{height: 40, width: 40, marginTop: -0.75}} />
                )}
            </Button>
            <Menu
                anchorEl={anchorElement}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                {finalOptions.map((option: MenuObject, index: number) => (
                    <div key={`${option.text}-${index}`}>
                        <MenuItem onClick={() => handleOptionClick(option)}>
                            {option.text}
                        </MenuItem>
                        {option.dividerNext && <Divider />}
                    </div>
                ))}
            </Menu>
        </Box>
    );
};

export default MenuComponent;
